import type { ReactNode } from 'react';
import type { FieldSchema } from '../../types';
import type { Group } from '../../models/Group';
import { useFormContext } from '../../context/FormContext';

export function CalloutField({
  fieldSchema,
  children,
}: {
  fieldSchema: FieldSchema;
  group: Group;
  children?: ReactNode;
}) {
  const { displayService } = useFormContext();
  const calloutId = fieldSchema.calloutId || fieldSchema.id;
  const statusClass = fieldSchema.calloutStatus ? `callout--${fieldSchema.calloutStatus}` : undefined;

  if (displayService.showCallout && !displayService.showCallout(calloutId)) {
    return null;
  }

  return (
    <div className="stepform-question-wrapper">
      <div className={`callout${statusClass ? ` ${statusClass}` : ''}`}>
        {children ?? (
          <div dangerouslySetInnerHTML={{ __html: fieldSchema.text || '' }} />
        )}
      </div>
    </div>
  );
}
